import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription, zip } from 'rxjs';
import { AbinResultDto } from 'src/app/inge-api/abinclient/models';
import { InventeringsNiva, InGeApiState } from 'src/app/store/state-model/inge-api.model';
import { UiTableConfig } from 'src/app/ui-components/ui-table/ui-table/models/tableConfig';
import { Store, select } from '@ngrx/store';
import { formatNumber } from '@angular/common';

@Component({
    selector: 'app-foder-tradslagssammansattning-table',
    templateUrl: './foder-tradslagssammansattning-table.component.html',
    styleUrls: ['./foder-tradslagssammansattning-table.component.scss']
})
export class FoderTradslagssammansattningTableComponent implements OnInit, OnDestroy {
    inventeringar$: Observable<AbinResultDto[]>;
    inventeringarLoading$: Observable<boolean>;
    inventeringarError$: Observable<boolean>;
    tableConfig: UiTableConfig = {
        columns: [
            { title: 'Trädslag', dataProperty: 'tradslag' },
            { title: 'Alla bestånd', dataProperty: 'allaBestand' },
            { title: 'Föryngrad med tall', dataProperty: 'foryngradMedTall' },
            { title: 'Föryngrad med gran', dataProperty: 'foryngradMedGran' }
        ],
        rowActions: []
    };

    tableCaption = '';

    tableContent = [];

    showAsteriskTextTall: boolean = false;
    showAsteriskTextGran: boolean = false;

    private subs: Subscription[] = [];
    constructor(private store: Store<InGeApiState>) {
        this.inventeringar$ = this.store.pipe(select((x) => x.abin.inventeringar));
        this.inventeringarLoading$ = store.pipe(select((x) => x.abin.loadingInventeringar));
        this.inventeringarError$ = store.pipe(select((x) => x.abin.inventeringarError));
    }

    ngOnInit(): void {
        this.subs.push(
            this.inventeringar$.subscribe((x) => {
                if (x && x.length > 0) {
                    const senasteInv = x[0];
                    this.tableConfig = {
                        columns: [
                            { title: 'Trädslag', dataProperty: 'tradslag' },
                            {
                                title: 'Alla bestånd',
                                dataProperty: 'allaBestand'
                            },
                            { title: 'Föryngrad med tall', dataProperty: 'foryngradMedTall' },
                            { title: 'Föryngrad med gran', dataProperty: 'foryngradMedGran' }
                        ],
                        rowActions: []
                    };
                    const totalFordelning = this.getForyngradeTradslagTotal(senasteInv);
                    const getTallAsterisk = this.getAsterisk(senasteInv.foryngTallHa3InvMedel, totalFordelning);
                    const getGranAsterisk = this.getAsterisk(senasteInv.foryngGranHa3InvMedel, totalFordelning, true);
                    this.tableContent = [
                        {
                            tradslag: 'Tall',
                            allaBestand: formatNumber(senasteInv.antalTallarHa3InvAVG, 'sv'),
                            foryngradMedTall: formatNumber(senasteInv.antalTallarForyngTallHa3InvAVG, 'sv') + getTallAsterisk,
                            foryngradMedGran: formatNumber(senasteInv.antalTallarForyngGranHa3InvAVG, 'sv') + getGranAsterisk
                        },
                        {
                            tradslag: 'Gran',
                            allaBestand: formatNumber(senasteInv.antalGranarHa3InvAVG, 'sv'),
                            foryngradMedTall: formatNumber(senasteInv.antalGranarForyngTallHa3InvAVG, 'sv') + getTallAsterisk,
                            foryngradMedGran: formatNumber(senasteInv.antalGranarForyngGranHa3InvAVG, 'sv') + getGranAsterisk
                        },

                        {
                            tradslag: 'Björk',
                            allaBestand: formatNumber(senasteInv.antalBjorkarHa3InvAVG, 'sv'),
                            foryngradMedTall: formatNumber(senasteInv.antalBjorkarForyngTallHa3InvAVG, 'sv') + getTallAsterisk,
                            foryngradMedGran: formatNumber(senasteInv.antalBjorkarForyngGranHa3InvAVG, 'sv') + getGranAsterisk
                        },
                        {
                            tradslag: 'Övriga produktionsträdslag',
                            allaBestand: formatNumber(senasteInv.antalOvrigtHa3InvAVG, 'sv'),
                            foryngradMedTall: formatNumber(senasteInv.antalOvrigtForyngTallHa3InvAVG, 'sv') + getTallAsterisk,
                            foryngradMedGran: formatNumber(senasteInv.antalOvrigtForyngGranHa3InvAVG, 'sv') + getGranAsterisk
                        },
                        {
                            tradslag: 'RASE',
                            allaBestand: formatNumber(senasteInv.antalRASEHa3InvAVG, 'sv'),
                            foryngradMedTall: formatNumber(senasteInv.antalRASEForyngTallHa3InvAVG, 'sv') + getTallAsterisk,
                            foryngradMedGran: formatNumber(senasteInv.antalRASEForyngGranHa3InvAVG, 'sv') + getGranAsterisk
                        },
                        {
                            tradslag: 'Totalt',
                            allaBestand: formatNumber(this.getTotalStammarHa3Inv(senasteInv), 'sv'),
                            foryngradMedTall: formatNumber(this.getTotalForyngradMedTall(senasteInv), 'sv') + getTallAsterisk,
                            foryngradMedGran: formatNumber(this.getTotalForyngradMedGran(senasteInv), 'sv') + getGranAsterisk
                        }
                    ];

                    this.showAsteriskTextTall = getTallAsterisk !== '';
                    this.showAsteriskTextGran = getGranAsterisk !== '';
                }
            })
        );
    }

    getTotalForyngradMedTall(inv: AbinResultDto): number {
        return Math.round(
            (inv.antalTallarForyngTallHa3InvAVG || 0) +
                (inv.antalGranarForyngTallHa3InvAVG || 0) +
                (inv.antalBjorkarForyngTallHa3InvAVG || 0) +
                (inv.antalOvrigtForyngTallHa3InvAVG || 0) +
                (inv.antalRASEForyngTallHa3InvAVG || 0)
        );
    }

    getTotalForyngradMedGran(inv: AbinResultDto): number {
        return Math.round(
            (inv.antalTallarForyngGranHa3InvAVG || 0) +
                (inv.antalGranarForyngGranHa3InvAVG || 0) +
                (inv.antalBjorkarForyngGranHa3InvAVG || 0) +
                (inv.antalOvrigtForyngGranHa3InvAVG || 0) +
                (inv.antalRASEForyngGranHa3InvAVG || 0)
        );
    }

    getTotalStammarHa3Inv(inv: AbinResultDto): number {
        return Math.round(
            (inv.antalTallarHa3InvAVG || 0) +
                (inv.antalGranarHa3InvAVG || 0) +
                (inv.antalBjorkarHa3InvAVG || 0) +
                (inv.antalOvrigtHa3InvAVG || 0) +
                (inv.antalRASEHa3InvAVG || 0)
        );
    }

    private getAsterisk(medelVarde: number, totalFordelning: number, isGran: boolean = false): string {
        const value = Math.round((medelVarde / totalFordelning) * 100);
        // Är andelen mindre än 20% så ska vi visa en asterisk.
        if (value < 20 && !isGran) {
            return ' *';
        } else if (value < 20 && isGran) {
            return ' **';
        }
        return '';
    }

    /**
     * Return the total number of foryngrade tradslag in the given inventory
     * @param {AbinResultDto} inv the inventory to get the total from
     * @return {number} the total number of foryngrade tradslag
     */
    getForyngradeTradslagTotal(inv: AbinResultDto): number {
        return (
            (inv.foryngTallHa3InvMedel || 0) +
            (inv.foryngBjorkHa3InvMedel || 0) +
            (inv.foryngContortaHa3InvMedel || 0) +
            (inv.foryngGranHa3InvMedel || 0) +
            (inv.foryngIngenHa3InvMedel || 0) +
            (inv.foryngLarkHa3InvMedel || 0) +
            (inv.foryngOvrigtHa3InvMedel || 0)
        );
    }

    ngOnDestroy(): void {
        this.subs.forEach((x) => x.unsubscribe());
    }
}
